import { useLocation } from "react-router";
import { useMemo } from "react";

export const useQuery = () => {
  const location = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(location.search);

    return {
      pickupZip: params.get("pickupZip"),
      pickupPlaceName: params.get("pickupPlaceName"),
      pickupStateCode: params.get("pickupStateCode"),
      pickupWithZip: params.get("pickupWithZip") === "true",
      deliveryZip: params.get("deliveryZip"),
      deliveryPlaceName: params.get("deliveryPlaceName"),
      deliveryStateCode: params.get("deliveryStateCode"),
      deliveryWithZip: params.get("deliveryWithZip") === "true",
      trailerType: params.get("trailerType"),
      outboundRatio: params.get("outboundRatio"),
      volume: params.get("volume"),
      pickupDate: params.get("pickupDate"),
      pickupDateEnd: params.get("pickupDateEnd"),
      deliveryDate: params.get("deliveryDate"),
      deliveryDateEnd: params.get("deliveryDateEnd"),
      outboundDuration: params.get("outboundDuration"),
      extendedMarket: params.get("extendedMarket") !== "false",
      withLoads: params.get("withLoads") === "true",
      page: params.get("page"),
      sortBy: params.get("sortBy"),
      sortDirection: params.get("sortDirection"),
      pickupRadius: params.get("pickupRadius"),
      deliveryRadius: params.get("deliveryRadius"),
      pickupMarket: params.get("pickupMarket"),
    };
  }, [location]);
};

export const markToRatio = (mark) => {
  switch (mark) {
    case 4:
      return 0.9;
    case 3:
      return 0.7;
    case 1:
      return 0.3;
    case 0:
      return 0.1;
    case 2:
    default:
      return 0.5;
  }
};

export const ratioToMark = (ratio) => {
  switch (ratio) {
    case "0.9":
      return 4;
    case "0.7":
      return 3;
    case "0.3":
      return 1;
    case "0.1":
      return 0;
    case "0.5":
    default:
      return 2;
  }
};

export const hasDigits = (query) => query && /^\d+$|^[A-Za-z\s]+,\s?[A-Za-z]{2},\s?\d+$/.test(query);
export const digitsOnly = (query) => query && /^\d+$/.test(query);
